import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageHandlerService {

    constructor() {
    }

    // token handler

    static setJwtToken(value: any) {
        localStorage.setItem(LocalStorageValues.JwtToken, value);
    }

    static getJwtToken() {
        return localStorage.getItem(LocalStorageValues.JwtToken);
    }

    static removeJwtToken() {
        localStorage.removeItem(LocalStorageValues.JwtToken);
    }

    // user handler

    static setCurrentUser(value: any) {
        localStorage.setItem(LocalStorageValues.currentUser, value);
    }

    static getCurrentUser() {
        return localStorage.getItem(LocalStorageValues.currentUser);
    }

    static removeCurrentUser() {
        localStorage.removeItem(LocalStorageValues.currentUser);
    }

    static clearAll() {
        localStorage.clear();
    }


}

export enum LocalStorageValues {
    JwtToken = 'JwtToken',
    currentUser = 'currentUser'
}
